import React, { useEffect, useState } from "react";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import EmbedDynamicExample from "components/Pages/EditEmbedPage/EditEmbedPageContent/EditEmbedPageBody/EmbedDynamicExample.js";
import Link from "components/Elements/Link/Link.js";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { contains_heb } from "utils/hebrewOrArabicText.js";

const SingleForm = ({
  FullDetailsEmbedPage,
  formSelected,
  setFormSelected,
  openSidePanel,
  formDetails,
  setFormDetails,
  embedIframe,
  setEmbedIframe,
  userNamePage,
  clearFormDetails,
  formList,
  singleForm,
  brandingColor,
  pageLanguage,
  displayFormDetails,
}) => {
  const [finishUploadProcess, setFinishUploadProcess] = useState(false);
  //FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageStatusMode === ("publish");
  const { getTextByKey, getDirection } = useContent();
  const { desktopCondition } = useMediaQueries();
  const returnToHome = () => {
    clearFormDetails();
  };
  const handleFinishUploadProcess = (val) => {
    setFinishUploadProcess(val);
  };
  useEffect(() => {
    if (formList.length > 0) {
      let tempForm = formList.filter(
        (item) => item.EmbedPageFormId === Number(formSelected)
      )[0];
      setFormDetails(tempForm);
    }
  }, [formList, formSelected]);

  useEffect(() => {
    if (formDetails) {
      setEmbedIframe({
        Embed_Dynamic_Width: formDetails.EmbedPageFormWidth,
        Embed_Dynamic_Height: formDetails.EmbedPageFormHeight,
        Embed_Dynamic_Id: formDetails.EmbedPageFormId,
      });
    }
  }, [formDetails]);

  return (
    <div
      className={`single-form-container ${
        openSidePanel ? "open-side-panel" : ""
      } ${!displayFormDetails ? "hide-form-details" : ""}`}
    >
      {formDetails && (
        <>
          <div className={`description-section`}>
            <div
              className="description-container"
              style={{
                direction: contains_heb(formDetails.EmbedPageFormInnerTitle),
              }}
            >
              {!singleForm && openSidePanel && (
                <div
                  className="back-button"
                  style={{
                    direction: contains_heb(
                      formDetails.EmbedPageFormInnerTitle
                    ),
                  }}
                  onClick={() => returnToHome()}
                >
                  <Link to={`/page/${userNamePage}`}>
                    <Image
                      style={{
                        direction: contains_heb(
                          formDetails.EmbedPageFormInnerTitle
                        ),
                      }}
                      title=""
                      alt=""
                      name="personal/back-forms"
                      ext="png"
                    />
                    <span>{getTextByKey("back-home")}</span>
                  </Link>
                </div>
              )}
              {
                <div className="form-details">
                  {!openSidePanel ? (
                    <>
                      {formDetails.EmbedPageFormImage && (
                        <div className="image-form-div">
                          {!singleForm && !openSidePanel && (
                            <div
                              className="back-button"
                              onClick={() => returnToHome()}
                            >
                              <Link to={`/page/${userNamePage}`}>
                                <Image
                                  title=""
                                  alt=""
                                  name="personal/back-forms"
                                  ext="png"
                                />
                                <span>{getTextByKey("back-home")}</span>
                              </Link>
                            </div>
                          )}
                          <div className="form-image">
                            <Image
                              src={formDetails.EmbedPageFormImage}
                              alt=""
                              title=""
                            />
                          </div>
                        </div>
                      )}
                      <div className="title-and-text">
                        <h2
                          style={{
                            direction: contains_heb(
                              formDetails.EmbedPageFormInnerTitle
                            ),
                          }}
                          className={`${
                            formDetails.EmbedPageFormInnerTitle.length > 20
                              ? "above20"
                              : formDetails.EmbedPageFormInnerTitle.length > 15
                              ? "above15"
                              : formDetails.EmbedPageFormInnerTitle.length > 9
                              ? "above9"
                              : ""
                          }`}
                        >
                          {parse(formDetails.EmbedPageFormInnerTitle)}
                        </h2>
                        {formDetails.EmbedPageFormDescription && (
                          <p
                            style={{
                              direction: contains_heb(
                                formDetails.EmbedPageFormDescription
                              ),
                            }}
                          >
                            {parse(formDetails.EmbedPageFormDescription)}
                          </p>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="title-and-text">
                        <h2
                          style={{
                            direction: contains_heb(
                              formDetails.EmbedPageFormInnerTitle
                            ),
                          }}
                          className={`${
                            formDetails.EmbedPageFormInnerTitle.length > 26
                              ? "above26"
                              : formDetails.EmbedPageFormInnerTitle.length > 14
                              ? "above20"
                              : formDetails.EmbedPageFormInnerTitle.length > 12
                              ? "above15"
                              : formDetails.EmbedPageFormInnerTitle.length > 10
                              ? "above10"
                              : ""
                          }`}
                        >
                          {parse(formDetails.EmbedPageFormInnerTitle)}
                        </h2>
                      </div>
                      {formDetails.EmbedPageFormImage && (
                        <div className="form-image">
                          <Image
                            src={formDetails.EmbedPageFormImage}
                            alt=""
                            title=""
                          />
                        </div>
                      )}
                      {formDetails.EmbedPageFormDescription && (
                        <p
                          style={{
                            direction: contains_heb(
                              formDetails.EmbedPageFormDescription
                            ),
                          }}
                        >
                          {parse(formDetails.EmbedPageFormDescription)}
                        </p>
                      )}
                    </>
                  )}
                </div>
              }
            </div>
          </div>
          <div className="description-section-mobile">
            <div className="description-container-mobile">
              {!singleForm && (
                <div className="back-button" onClick={() => returnToHome()}>
                  <Link to={`/page/${userNamePage}`}>
                    <Image
                      title=""
                      alt=""
                      name="personal/back-forms"
                      ext="png"
                    />
                    <span>{getTextByKey("back-home")}</span>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="form-section">
            <div className="tablet-and-mobile">
              {!desktopCondition || !displayFormDetails
                ? !singleForm && (
                    <div className="back-button" onClick={() => returnToHome()}>
                      <Link to={`/page/${userNamePage}`}>
                        <Image
                          title=""
                          alt=""
                          name="personal/back-forms"
                          ext="png"
                        />
                        <span>{getTextByKey("back-home")}</span>
                      </Link>
                    </div>
                  )
                : null}
              <div className="render-form-mobile">
                <EmbedDynamicExample
                  activeFormInJumboFormsPage={
                    FullDetailsEmbedPage &&
                    FullDetailsEmbedPage.EmbedDynamicPage &&
                    FullDetailsEmbedPage.EmbedDynamicPage
                      .EmbedPageStatusMode === "publish"
                      ? true
                      : false
                  }
                  embedPageFormImage={formDetails.EmbedPageFormImage}
                  brandingColor={brandingColor}
                  selectedForm={embedIframe}
                  formInEmbedPage={true}
                  hideFooter={true}
                  includeTitleAndDesc={!desktopCondition}
                  handleFinishUploadProcess={handleFinishUploadProcess}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SingleForm;
